export default {
    baseApi:process.env.VUE_APP_URL,
    token:process.env.VUE_APP_TOKEN
}